export const timer = (time, callback) => {
  return setTimeout(() => {
    callback();
  }, time);
};